import { render, staticRenderFns } from "./RecordCol.vue?vue&type=template&id=33ee8e0e&scoped=true"
import script from "./RecordCol.vue?vue&type=script&lang=js"
export * from "./RecordCol.vue?vue&type=script&lang=js"
import style1 from "./RecordCol.vue?vue&type=style&index=1&id=33ee8e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee8e0e",
  null
  
)

export default component.exports